import { memo } from "react";
function RouteStartedIcon({ color = "#05A792", width, height }) {
  return (
    <svg
      width={width ?? "16"}
      height={height ?? "16"}
      viewBox="0 0 40 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.9 23C26.6 22.7 26.45 22.3417 26.45 21.925C26.45 21.5083 26.6 21.15 26.9 20.85L34.25 13.5H9.45C9.01667 13.5 8.65833 13.3583 8.375 13.075C8.09167 12.7917 7.95 12.4333 7.95 12C7.95 11.5667 8.09167 11.2083 8.375 10.925C8.65833 10.6417 9.01667 10.5 9.45 10.5H34.25L26.9 3.1C26.6 2.8 26.45 2.45 26.45 2.05C26.45 1.65 26.6 1.3 26.9 1C27.2 0.7 27.55 0.55 27.95 0.55C28.35 0.55 28.7 0.7 29 1L38.95 10.95C39.1167 11.1167 39.2333 11.2833 39.3 11.45C39.3667 11.6167 39.4 11.8 39.4 12C39.4 12.2 39.3667 12.3833 39.3 12.55C39.2333 12.7167 39.1167 12.8833 38.95 13.05L29 23C28.7 23.3 28.35 23.45 27.95 23.45C27.55 23.45 27.2 23.3 26.9 23ZM1.5 24C1.06667 24 0.708333 23.8583 0.425 23.575C0.141667 23.2917 0 22.9333 0 22.5V1.5C0 1.06667 0.141667 0.708333 0.425 0.425C0.708333 0.141667 1.06667 0 1.5 0C1.93333 0 2.29167 0.141667 2.575 0.425C2.85833 0.708333 3 1.06667 3 1.5V22.5C3 22.9333 2.85833 23.2917 2.575 23.575C2.29167 23.8583 1.93333 24 1.5 24Z"
        fill={color}
        stroke={color}
        strokeWidth={2}
      />
    </svg>
  );
}

export default memo(RouteStartedIcon);
